import dateFormatType from '@/constants/dateFormatType';
import { beforeDays } from '@/utils/time';
import { format } from 'date-fns';
const today = new Date();
const initialFromDate = format(beforeDays(today, 1), dateFormatType.DATE);
const initialToDate = format(today, dateFormatType.DATE);
const dialogDefaultPageSize = 10;
const firstPage = 1;
export const getInitialState = () => ({
    // 다이얼로그
    dialogDetail: {
        workerCode: '',
        workerName: '',
        hubId: '',
    },
    filterOption: {
        fromDate: initialFromDate,
        toDate: initialToDate,
    },
    sortOption: [
        {
            // 정렬 대상
            field: '',
            // 정렬 기준
            value: '',
        },
    ],
    pageSize: dialogDefaultPageSize,
    pageNumber: firstPage,
    // 데이터
    workerBaromoneyHistoryByWorkerCodeList: [],
    paginationData: {},
});
const states = getInitialState();
export default states;
